<div class="last-updated-container">
  <i class="icon pi pi-refresh" (click)="onRefresh()"></i>
  @if (refreshing) {
  <div class="last-updated-text">Refreshing...</div>
  } @else {
  <div class="last-updated-text">{{ lastUpdatedText }}</div>
  }
</div>
